import React, { useEffect, useState } from "react";

import { Button } from "reactstrap";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { getDropdownTypeList } from "../../../../service/rak-beneficiary-service";

const RechargeTransactionFilter = ({
  show = false,
  onHide,
  saveButtonClicked,
  type,
  setType,
  status,
  setStatus,
}) => {
  // const [type, setType] = useState([]);
  // const [status, setStatus] = useState([]);
  const [typeLength, setTypeLength] = useState("");
  const [statusLength, setStatusLength] = useState("");

  const [typeList, setTypeList] = useState([
    { value: "local", label: "Local" },
    { value: "International", label: "International" },
  ]);

  const [statusList, setStatusList] = useState([
    { value: "successful", label: "Successful" },
    { value: "Pending", label: "Pending" },
    { value: "Failed", label: "Failed" },
  ]);

  // useEffect(() => {
  //   setType(searchType);
  //   setStatus(searchStatus);
  // }, [searchType, searchStatus]);
  return (
    <>
      <Modal
        onHide={onHide}
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="rak-beneficiary-modal"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Select
              closeMenuOnSelect={true}
              isMulti
              placeholder="Type"
              onChange={(data) => {
                setType(data);
                setTypeLength((data && data.length) || 0);
              }}
              options={typeList}
              value={type}
            />
          </div>
        </Modal.Body>
        <Modal.Body>
          <div>
            <Select
              closeMenuOnSelect={true}
              isMulti
              placeholder="Status"
              onChange={(data) => {
                setStatus(data);
                setStatusLength((data && data.length) || 0);
              }}
              options={statusList}
              value={status}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              onHide();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            color="primary"
            onClick={() => {
              let req = {};
              req.searchType = type;
              req.searchStatus = status;
              req.typeLength = type.length;
              req.statusLength = status.length;
              req.totalLength = req.typeLength + req.statusLength;
              saveButtonClicked(req);
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RechargeTransactionFilter;
